import * as React from 'react';
import {LegacyModal} from '@flexe/ui-components';
import {format} from 'date-fns';
import {ContainerDelivery} from '../shared/DropoffInterfaces';

interface Props {
  showModal: boolean;
  toggleModal: () => void;
  containerDelivery: ContainerDelivery;
  onConfirmLpnDropoff: () => void;
}

export const ConfirmLpnDropoffModal: React.FC<Props> = (props) => {
  return (
    <LegacyModal
      id="complete_modal"
      show={props.showModal}
      size="small"
      title="Confirm Arrival"
      toggleModal={props.toggleModal}
      footer={
        <div>
          <a className="btn" onClick={props.toggleModal}>
            Cancel
          </a>
          <a className="btn btn-modal-complete" onClick={props.onConfirmLpnDropoff}>
            Confirm
          </a>
        </div>
      }
    >
      <p>
        This delivery is scheduled to arrive in the future.
        <br />
        Are you sure you want to confirm this delivery early?
      </p>
    </LegacyModal>
  );
};

export default ConfirmLpnDropoffModal;
